import * as yup from 'yup'

export const URL = /https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

export const required = yup.string().required('error.required')

export const validUrl = required.matches(URL, 'error.invalid.url')
